import { render, staticRenderFns } from "./XmPoster.vue?vue&type=template&id=0f7d28e1&scoped=true"
import script from "./XmPoster.vue?vue&type=script&lang=js"
export * from "./XmPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d28e1",
  null
  
)

export default component.exports